/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { FormEventHandler, ReactNode } from "react";
import { Box, Grid, Hidden, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import FormLegend from "../FormLegend/FormLegend";
import FormSubmit from "../FormSubmit/FormSubmit";
import FormFader from "../Fader/FormFader";
import formHeaderWrapperStyle from "./formHeaderWrapperStyles";
import FormSubmitProps from "../../../../types/FormSubmitProps";

type FormHeaderWrapperProps = {
  children: ReactNode;
  submitProps: FormSubmitProps;
  handleSubmit: FormEventHandler;
};

export function FormHeaderWrapper({ children, submitProps, handleSubmit }: FormHeaderWrapperProps) {
  return (
    <Paper elevation={4} sx={formHeaderWrapperStyle.paper}>
      <FormFader>
        <Box component={"form"} sx={formHeaderWrapperStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={formHeaderWrapperStyle.headline}>
              Ihr Vertrag
            </Typography>
          </Hidden>
          <Grid container justifyContent={"flex-start"} alignItems={"baseline"}>
            <Grid item xs={12}>
              <FormLegend>
                <strong>Details zu Ihrem Vertrag</strong>
              </FormLegend>
            </Grid>
            {children}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
